import { memo } from 'react';

const Label_: React.FC2 = ({ children, className }) => {
  return <span className={className}>{children}</span>;
};

export const Label = memo(Label_);
